// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
export const environment = {
    production: false,
    firebaseProject: process.env.NX_FIREBASE_PROJECT || "MedDBriefer",
    classCode: process.env.NX_CLASS_CODE || "test-content"
};
